import React, { useEffect, useState } from 'react'
import Sidebar from './component/sidebar'
import MainContent from './component/maincontent'
import TooltipWalkthrough from '../../util/walkthrough'
import { useSubscription } from '../../context/subscriptionprovider'
import AccessRestrictedOverlay from '../../components/restrictoverlay'
import Loader from '../../components/loader'
import useChatbotLoader from '../../util/chatbotloader'
import ChatbotLoader, {
  rebuildChatbot,
  deleteChatbotScript
} from '../../util/loadExternalScript'
import { ToastContainer, toast } from 'react-toastify'
import { useAuth } from '../../context/logincontext'

const Training = () => {
  const [active, setActive] = useState(1)
  const [loading, setLoading] = useState(true)
  const [jsbundle, setjsbundle] = useState('') // Manage chatbot script URL
  const [GetStoreId, setGetStoreId] = useState('') // Manage storeId state
  const { isRestricted, activePlan, limitedPermission } = useSubscription()
  const [showChatbot, SetshowChatbot] = useState(false)
  const {userdata} = useAuth()

  console.log(userdata);

  // const handleManualLoad = storeId => {
  //   if (storeId) {
  //     setGetStoreId(storeId)
  //     setjsbundle(process.env.REACT_APP_API_URL + '/js/loader.bundle.js')
  //     window.dispatchEvent(new CustomEvent('removescript', { detail: true }))
  //   }
  // }
  // const shouldLoad = GetStoreId && jsbundle
  // useChatbotLoader(shouldLoad ? jsbundle : '', shouldLoad ? GetStoreId : '')
  useEffect(() => {
    const handletriggerpreview = event => {
      if (event.detail) {
        toast.info('Please wait while generating...', {
          containerId: 'preview-toast'
        })
        // const storeId = localStorage.getItem('store_id')
        // handleManualLoad(storeId)
        SetshowChatbot(true)
        // Wait until chatbotConfig is available before opening
        const interval = setInterval(() => {
          if (window.chatbotConfig) {
            window.chatbotConfig.open = true
            clearInterval(interval) // stop checking
          }
        }, 1000)
        // rebuildChatbot()
      } else {
        SetshowChatbot(false)
        // deleteChatbotScript();
      }
    }
    window.addEventListener('triggerpreview', handletriggerpreview)
    window.addEventListener('removepreview', handletriggerpreview)
    return () => {
      window.removeEventListener('triggerpreview', handletriggerpreview)
      window.removeEventListener('removepreview', handletriggerpreview)
    }
  }, [showChatbot])

  useEffect(() => {
    // Simulate API delay or loading check
    const delay = setTimeout(() => {
      setLoading(false)
    }, 800) // adjust if needed (or remove if your subscription context already has a loading state)

    return () => clearTimeout(delay)
  }, [isRestricted, activePlan, limitedPermission])

  if (loading) {
    return (
      <div className='min-h-[29.1rem] h-full flex items-center justify-center'>
        <div className='text-center text-gray-500 animate-pulse'>
          <Loader />
        </div>
      </div>
    )
  }

  if (isRestricted) {
    return (
      <div className='min-h-[29.1rem] h-full relative'>
        <AccessRestrictedOverlay
          content={
            'Unlock personalized training and datasets. Upgrade your subscription to start training your AI assistant today.'
          }
        />
      </div>
    )
  }

  return (
    <div className='min-h-[29.1rem] h-full relative'>
      <div className='relative block md:flex'>
        <Sidebar active={active} setActive={setActive} />
        <MainContent active={active} />
        <TooltipWalkthrough pageKey='/training' />
        {showChatbot && <ChatbotLoader />}
      </div>
      <ToastContainer containerId='preview-toast' position='bottom-center' />
    </div>
  )
}

export default Training
